import React, {useState, setGlobal, getGlobal, useEffect} from 'reactn';
import { Radio, Checkbox, Button, Switch, notification, Popover, Tabs} from 'antd';
import { useFirestore } from 'reactfire';

import Discharge from './Discharge';
import NasalObstruction from './NasalObstruction';
import Pain from './Pain';
import HistoryOfNasalSymptomsWithComplication from './HistoryOfNasalSymptomsWithComplication';

const Nasal = (props) => {
    const { TabPane } = Tabs;
    const [IsSymptom, setSymptom] = useState('No');

    useEffect(() => {
        
        if (getGlobal().ChiefComplaints_location) {
            const ChiefComplainValue = getGlobal().ChiefComplaints_location;
            setSymptom(ChiefComplainValue ? 'Yes' : 'No');
        }
    }, [props]);

    // useMemo(() => {
    //     if (getGlobal().ChiefComplaints_location) {
    //         const ChiefComplainValue = getGlobal().ChiefComplaints_location;
    //         setSymptom(ChiefComplainValue ? 'Yes' : 'No');
    //     }
    // }, [props])
    
    const SymptomSelect = (event) => {
        setSymptom(event.target.value);
    }
    


    const docSaved = () => {
        props.hasSaved();
    }

    return (
        <div>
            <React.Fragment>

            <Radio.Group value={IsSymptom} buttonStyle="solid" size="large" onChange={SymptomSelect} style={{marginTop: '20px'}}>
                        <Radio.Button value={'Yes'}>Symptoms</Radio.Button>
                        <Radio.Button value={'No'}>No Symptoms</Radio.Button>
                    </Radio.Group>
                    {IsSymptom === 'Yes'? 

                        <Tabs>
                            <TabPane tab="Discharge" key="Discharge">
                                <Discharge hasSaved={docSaved} /> 
                            </TabPane>
                            <TabPane tab="Nasal Obstruction" key="Nasal Obstruction">
                                <NasalObstruction hasSaved={docSaved} /> 
                            </TabPane>
                            <TabPane tab="Pain" key="Pain">
                                <Pain hasSaved={docSaved} />
                            </TabPane>
                            <TabPane tab="History Of Nasal Symptoms With Complication" key="History Of Nasal Symptoms With Complication">
                                <HistoryOfNasalSymptomsWithComplication hasSaved={docSaved} />
                            </TabPane>
                            
                        </Tabs>
                    : ''}
            </React.Fragment>
            
        </div>
    );
}

export default Nasal;
